import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Lightweight loading fallback shown while lazy-loaded route chunks
 * are being downloaded. Intended for use with React.Suspense wrapping
 * lazy-loaded route elements.
 */
export const RouteSuspenseFallback: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      gap: 2,
    }}
  >
    <CircularProgress color="primary" />
    <Typography variant="body2" color="text.secondary">
      Loading...
    </Typography>
  </Box>
);

export default RouteSuspenseFallback;
